import { render } from "./employee_documents_modal.vue?vue&type=template&id=4f5bddaf"
import script from "./employee_documents_modal.vue?vue&type=script&lang=js"
export * from "./employee_documents_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__